module.exports = __webpack_public_path__ + "static/media/Retro-Sprint-4-Audio-5.4011dc1d.mp3";